import Codepad from './Codepad';
import Canvas from './Canvas';
import TechnicalQuestion from './TechnicalQuestion';
import ProctorPanel from './ProctorPanel';
import AvatarPickerWidget from './AvatarPickerWidget';
import './WidgetPanel.css';

export default function WidgetPanel({
  activeWidget,
  codepadConfig,
  codeHighlights,
  insertCode,
  testCases,
  canvasDrawing,
  question,
  onCloseWidget,
  faceModel,
  faceModelReady,
  avatarList,
  selectedAvatarId,
  onSelectAvatar,
}) {
  return (
    <div className="widget-panel">
      {activeWidget === 'codepad' && (
        <Codepad
          language={codepadConfig.language}
          initialCode={codepadConfig.initialCode}
          highlights={codeHighlights}
          insertCode={insertCode}
          agentTestCases={testCases}
          onClose={onCloseWidget}
        />
      )}

      {activeWidget === 'canvas' && <Canvas initialDrawing={canvasDrawing} onClose={onCloseWidget} />}

      {activeWidget === 'question' && (
        <TechnicalQuestion question={question} onClose={onCloseWidget} />
      )}

      {activeWidget === 'proctor' && (
        <ProctorPanel onClose={onCloseWidget} faceModel={faceModel} faceModelReady={faceModelReady} />
      )}

      {activeWidget === 'avatar_picker' && (
        <AvatarPickerWidget
          avatars={avatarList}
          selectedId={selectedAvatarId}
          onSelect={onSelectAvatar}
        />
      )}
    </div>
  );
}
